export const headerBannerClicked = (text, target) => ({
  type: 'Header Banner Clicked',
  data: {
    text,
    target,
  },
});
